import React, { useState } from 'react';
import { FaEye, FaEyeSlash, FaLock, FaKey, FaShieldAlt } from 'react-icons/fa';
import './ChangePassword.css';
import axiosInstance from '../../api/axiosInstance';

const ChangePassword = () => {
  // Form State
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // Visibility State
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  
  // Feedback State
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
    setIsError(false);

    

    // 2. Empty Field Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      setMessage('All fields are required.');
      setIsError(true);
      setIsLoading(false);
      return;
    }

    // 3. Minimum Length Validation
    if (newPassword.length < 6) {
      setMessage('New password must be at least 6 characters long.');
      setIsError(true);
      setIsLoading(false);
      return;
    }

    // 4. Match Validation
    if (newPassword !== confirmPassword) {
      setMessage('New passwords do not match.');
      setIsError(true);
      setIsLoading(false);
      return;
    }

    // 5. API Call
    try {
      // axiosInstance automatically handles base URL and JSON headers
      const response = await axiosInstance.post('/api/admin/change-password', {
        currentPassword,
        newPassword,
        confirmPassword,
      });

      // Success (Axios throws an error if status is not 2xx, so we land here on success)
      setMessage(response.data.message || 'Password updated successfully.');
      setIsError(false);
      
      // Clear fields
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      
      // Reset visibility
      setShowCurrent(false);
      setShowNew(false);
      setShowConfirm(false);

    } catch (error) {
      // Handle Axios Errors
      const errorMsg = error.response?.data?.message || error.message || 'Something went wrong';
      setMessage(errorMsg);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="change-password-admin-container">
      <form className="change-password-admin-card" onSubmit={handleSubmit} noValidate>
        
        <div className="change-password-admin-header">
            <div className="change-password-icon-circle">
                <FaShieldAlt className="change-password-admin-header-icon" />
            </div>
            <h2>Change Password</h2>
            <p>Ensure your account stays secure</p>
        </div>
        
        {message && (
          <div className={`change-password-admin-message ${isError ? 'error' : 'success'}`}>
            {message}
          </div>
        )}
        
        {/* Current Password */}
        <div className="change-password-admin-group">
          <label htmlFor="currentPassword">Current Password</label>
          <div className="change-password-admin-input-wrapper">
            <FaKey className="change-password-admin-field-icon" />
            <input
                type={showCurrent ? "text" : "password"}
                id="currentPassword"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Enter current password"
                required
            />
            <button 
                type="button"
                className="change-password-admin-eye-btn"
                onClick={() => setShowCurrent(!showCurrent)}
                tabIndex="-1"
            >
                {showCurrent ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
        
        {/* New Password */}
        <div className="change-password-admin-group">
          <label htmlFor="newPassword">New Password (Min 6 chars)</label>
          <div className="change-password-admin-input-wrapper">
            <FaLock className="change-password-admin-field-icon" />
            <input
                type={showNew ? "text" : "password"}
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                required
            />
            <button 
                type="button"
                className="change-password-admin-eye-btn"
                onClick={() => setShowNew(!showNew)}
                tabIndex="-1"
            >
                {showNew ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
        
        {/* Confirm Password */}
        <div className="change-password-admin-group">
          <label htmlFor="confirmPassword">Confirm New Password</label>
          <div className="change-password-admin-input-wrapper">
            <FaLock className="change-password-admin-field-icon" />
            <input
                type={showConfirm ? "text" : "password"}
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                required
            />
            <button 
                type="button"
                className="change-password-admin-eye-btn"
                onClick={() => setShowConfirm(!showConfirm)}
                tabIndex="-1"
            >
                {showConfirm ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
        
        <button type="submit" className="change-password-admin-btn" disabled={isLoading}>
          {isLoading ? 'Updating...' : 'Update Password'}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;